import s from "../partnerPortal.module.css";
import { Panel, SectionTitle } from "./shared";
import { TIERS, money } from "../portalData";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { partnerGetBilling } from "../../../services/partnerCalls";
import { errorHandler } from "../../../utils";
import { DEFAULT_ERROR_MESSAGE } from "../../../constants";

const COLS = "1.2fr 1.4fr 1fr 1.3fr";

export default function Billing({ currency, setCurrency }) {
  const [loading, setLoading] = useState(false);
  const [billingData, setBillingData] = useState(null);

  const fetchBilling = async () => {
    setLoading(true);
    try {
      const res = await partnerGetBilling();
      if (res?.data?.data) {
        setBillingData(res.data.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorHandler(error?.response?.data?.message || DEFAULT_ERROR_MESSAGE);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBilling();
  }, []);
  return (
    <div>
      <div className={s.pg29}
      >
        <SectionTitle
          title="Billing & Credits"
          sub="Upfront credit purchase — no invoicing. Commit annually for the lowest rate."
        />
        <div className={s.segment}>
          {["USD", "NGN"].map((option) => (
            <button
              key={option}
              type="button"
              className={`${s.segmentBtn} ${currency === option ? s.segmentBtnAltActive : ""}`}
              onClick={() => setCurrency(option)}
            >
              {option === "USD" ? "$ USD" : "₦ NGN"}
            </button>
          ))}
        </div>
      </div>

      <div className={`${s.grid2even} ${s.pg6}`}>
        <Panel>
          <div className={s.cardLabel}>Current plan</div>
          <div className={s.pg30}>{loading ? "…" : billingData?.tier?.name || "—"}</div>
          <div className={s.pg31}>
            {loading
              ? ""
              : `${(billingData?.balance ?? 0).toLocaleString()} of ${(
                  billingData?.allocation ?? 0
                ).toLocaleString()} credits remaining`}
          </div>
          <Link to="/api-integrations#contact" className={`${s.btnSolid} ${s.pg32}`}>
            Contact us for more credits
          </Link>
        </Panel>

        <Panel>
          <div className={s.cardLabel}>Recent transactions</div>
          {!loading && (billingData?.transactions || []).length === 0 && (
            <div className={s.pg34}>No transactions yet.</div>
          )}
          {(billingData?.transactions || []).slice(0, 4).map((t) => (
            <div key={t._id} className={s.pg34} style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ textTransform: "capitalize" }}>{t.transaction_type}</span>
              <span>{t.amount > 0 ? "+" : ""}{t.amount}C</span>
            </div>
          ))}
        </Panel>
      </div>

      <Panel flush>
        <div
          className={`${s.blockTitle} ${s.pg35}`}
        >
          Per-test credit tiers
        </div>

        <div className={s.pg36}>
          <div className={s.pg37}>
            <div className={s.tableHead} style={{ gridTemplateColumns: COLS }}>
              {[
                "Tier",
                "Annual commitment",
                "Per credit",
                "Business Analyst (3C)",
              ].map((h) => (
                <div key={h} className={s.th}>
                  {h}
                </div>
              ))}
            </div>

            {TIERS?.map((tier) => {
              const isCurrent =
                (billingData?.tier?.name || "").trim().toLowerCase() === tier.name.trim().toLowerCase();
              return (
              <div
                key={tier.name}
                className={s.tableRow}
                style={{
                  gridTemplateColumns: COLS,
                  background: isCurrent
                    ? "rgba(45,212,191,0.05)"
                    : "transparent",
                }}
              >
                <div
                  className={`${s.td} ${s.pg38}`}
                >
                  <span className={s.pg39}
                  >
                    {tier.name}
                  </span>
                  {isCurrent && (
                    <span className={s.pg40}
                    >
                      CURRENT
                    </span>
                  )}
                </div>
                <div className={`${s.td} ${s.pg41}`}>
                  {tier.commit}
                </div>
                <div
                  className={`${s.td} ${s.pg42}`}
                >
                  {money(tier.per, currency)}
                </div>
                <div className={`${s.td} ${s.pg43}`}>
                  {money(tier.per * 3, currency)}
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </Panel>

      <div className={s.note}>
        Credits are consumed when a session is created. A session a candidate
        never starts expires after 48 hours.
      </div>
    </div>
  );
}
